// Turn a duration in milliseconds into "just now", "12m ago", "3h 20m ago"
// or "2d 4h ago". Anything under a minute counts as "just now".
export function formatAgo(ms) {
  const totalMin = Math.floor(ms / 60000)
  if (totalMin < 1) return 'just now'

  const days = Math.floor(totalMin / 1440)
  const hours = Math.floor((totalMin % 1440) / 60)
  const minutes = totalMin % 60

  if (days > 0) return `${days}d ${hours}h ago`
  if (hours > 0) return `${hours}h ${minutes}m ago`
  return `${minutes}m ago`
}

// The label above the table. It only speaks up when something is wrong; a
// healthy feed that is delivering data gets no label at all (null).
//
// `seconds` is null until the first snapshot arrives. An open socket that has
// sent us nothing is its own state — it is what a reachable server with an
// unreachable database looks like — so it still gets a label.
export function feedLabel(status, seconds) {
  if (status === 'connecting') return 'connecting…'
  if (status === 'reconnecting') return 'reconnecting…'
  if (status === 'offline') return 'no live feed'

  if (seconds === null) return 'awaiting data'
  return null
}
